(function () {
  document.addEventListener('change', (event) => {
    const country = event.target.closest('[data-pp-country]');
    if (country) {
      country.form.submit();
      return;
    }
    const model = event.target.closest('[data-pp-model]');
    if (model && model.value) window.location.assign(model.value);
  });
})();
